import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 20px;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
`;

export const CheckboxCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 20px 0;
`;

export const SelectedCountText = styled.div`
  font-size: 14px;
  color: #666;
  margin: 10px 0;
  font-weight: 500;
`;
